import { render, staticRenderFns } from "./KnowledgeModal.vue?vue&type=template&id=5d4dc8f5&"
import script from "./KnowledgeModal.vue?vue&type=script&lang=js&"
export * from "./KnowledgeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports